import * as React from 'react';

import { SearchEvents, SearchEventsContext } from './search-events-context';

export interface SearchEventsContextProviderProps {
  searchEvents: SearchEvents;
}

export const SearchEventsContextProvider: React.FC<SearchEventsContextProviderProps> = ({ children, searchEvents }) => (
  <SearchEventsContext.Provider value={searchEvents}>{children}</SearchEventsContext.Provider>
);
